import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { makeCancelable } from '@upsales/components/Utils/CancelablePromise';

const propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.object,
	innerStyle: PropTypes.object,
	size: PropTypes.number,
	avatar: PropTypes.object,
	user: PropTypes.object.isRequired
};

class Avatar extends React.Component {
	constructor(props) {
		super(props);

		const size = props.size ? props.size : 30;

		this.state = {
			size: size,
			avatar: props.avatar
		};
	}

	componentDidMount() {
		this.updateAvatar();
	}

	componentDidUpdate(prevProps) {
		// If user ID changed and no avatar provided in props, fetch new avatar
		if (prevProps.user?.id !== this.props.user?.id || prevProps.avatar?.url !== this.props.avatar?.url) {
			this.updateAvatar();
		}
	}

	componentWillUnmount() {
		this.getter?.cancel();
	}

	updateAvatar() {
		if (this.getter) {
			this.getter.cancel();
		}

		if (this.props.avatar?.url) {
			this.setState({ avatar: this.props.avatar });
		} else {
			const avatarService = Tools.avatarService;
			this.getter = makeCancelable(avatarService.getAvatar(this.props.user));
			// eslint-disable-next-line promise/catch-or-return
			this.getter.promise.then(avatar => {
				this.setState({ avatar });
			});
		}
	}

	shouldComponentUpdate(newProps, newState) {
		return (
			newProps.user?.id !== this.props.user?.id ||
			newState.avatar?.url !== this.state.avatar?.url ||
			newProps.size !== this.props.size
		);
	}

	render() {
		const { size, avatar } = this.state;
		const { user, className } = this.props;

		if (user && user.name) {
			const tag = avatar.gravatar ? <img className="img" src={avatar.url} onError={this.onError} /> : null;

			const innerStyle = _.merge(
				{
					display: avatar.initials?.length ? 'block' : 'none',
					lineHeight: size + 'px'
				},
				this.props.innerStyle || {}
			);

			const outerStyle = _.merge(
				{
					width: size,
					height: size,
					fontSize: parseInt(size) / 2 + 'px'
				},
				this.props.style || {}
			);

			let classNames = 'generic-avatar round';
			if (className) {
				classNames += ' ' + className;
			}

			return (
				<div id={this.props.id || null} className={classNames} style={outerStyle}>
					<div className="color" style={innerStyle}>
						<span className="name" style={{ lineHeight: size + 'px' }}>
							{avatar.initials}
						</span>
					</div>
					{tag}
				</div>
			);
		}

		return <div />;
	}
}

Avatar.propTypes = propTypes;
Avatar.defaultProps = {
	avatar: {
		initials: '',
		url: '',
		gravatar: false
	}
};

export default Avatar;
